import _ from 'lodash';

export function transformSelectorElementsToValues(data) {
  return _.mapValues(data, (v) => {
    const selectorValue = _.get(v, 'value');
    return selectorValue || v;
  });
}
